

import React, { useState, useEffect } from 'react';
import Lottie from 'lottie-react';
import animationData from "./delete.json/delete.json";
import "bootstrap/dist/css/bootstrap.min.css"
import './DeleteAccount.css';
import { InputOTP } from 'antd-input-otp';
import { Container, Navbar, Form, Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import img from "./sr.png";
import { faIconName } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios'

const Home = () => {
    const [mobileNumber, setMobileNumber] = useState('');
    const [otp, setOtp] = useState('');
    const [otpSent, setOtpSent] = useState(false);
    const [otpVerified, setOtpVerified] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [otpTimer, setOtpTimer] = useState(30);

    const Baseurl = `https://sparkredeem.com/sparky/`

    useEffect(() => {
        let timer;
        if (otpSent && otpTimer > 0) {
            timer = setTimeout(() => {
                setOtpTimer(otpTimer - 1);
            }, 1000);
        }
        return () => clearTimeout(timer);
    }, [otpSent, otpTimer]);

    const sendOtp = () => {
        setOtpSent(true);
    };

    const verifyOtp = () => {
        if (otp.length === 4) {
            setOtpVerified(true);
        }
    };

    const deleteAccount = () => {
        if (otpVerified) {
            setShowPopup(true);
        }
    };


    // ------------------------------------------------------------------

    const getotp = (mobile) => {
        const formdata = new FormData()
        formdata.append('phone_num', mobile)
        axios.post(`${Baseurl}acc_del_otp`, formdata)
            .then((res) => {
                if (res.data.Response.Success == 1) {
                    console.log(res.data.Response.Message)
                }
                if (res.data.Response.Success == 0) {
                    alert(res.data.Response.Message)
                }
            })
            .catch((error) => {
                console.log(error);
                alert("Try again later")
            })
    }

    // --------------------------------------------------------------------------------------

    const [uid, setUid] = useState('')

    const otp_verify = (mobileNumber, otp) => {
        axios.get(`${Baseurl}accdel_OTP_verify?mobile=${mobileNumber}&otp=${otp}`)
            .then((res) => {
                if (res.data.Response.Success == 1) {
                    console.log(res.data.Response.Message)
                    setOtpVerified(true)
                    setUid(res.data.Response.userId)
                }
                if (res.data.Response.Success == 0) {
                    alert(res.data.Response.Message)
                }
            })
            .catch((error) => {
                console.log(error);
                alert("Try again later")
            })
    }



    // ------------------------------------------------------------------

    const delete_acc = (uid) => {
        axios.post(`https://sparkredeem.in/gig_workstation/Common/deactivate_user.php?uid=${uid}`)
            .then((res) => {
                if (res.data.Response.Success == 1) {
                    alert(res.data.Response.Message)
                    window.location.reload()

                }
                if (res.data.Response.Success == 0) {
                    alert(res.data.Response.Message)
                }
            })
            .catch((error) => {
                console.log(error);
                alert("Try again later")
            })
    }

    return (
        <>
            <div className="bg-white hea d-flex col-lg-12">
                <div className="col-lg-12 row">
                    <div className="col-lg-1"></div>
                    <div className="col-lg-10">
                        <Navbar bg="white" expand="lg">
                            <Container fluid>
                                <div className="col-lg-12 row">
                                    <div className="col-lg-3 d-flex">
                                        {/* <FontAwesomeIcon className="text-dark vouicon mb-3" icon={faBars} /> */}
                                        <Navbar.Brand href="#">
                                            <img
                                                alt=""
                                                src={img}
                                                width="200"
                                                height="55"
                                                className="justify-content-start mt-1"
                                            />
                                        </Navbar.Brand>
                                    </div>
                                    <div className="col-lg-2"></div>
                                    <div className="col-lg-4 mt-4">

                                    </div>
                                    <div className="col-lg-3 d-flex justify-content-end">

                                    </div>
                                </div>
                            </Container>
                        </Navbar>
                    </div>
                    <div className="col-lg-1"></div>
                </div>
            </div>
            <div className="container d-flex col-lg-12">
                <div className="animation">
                    <Lottie animationData={animationData} loop={true} />
                </div>
                <div className="form-container">
                    <h1>Delete Account</h1>
                    <p>We are sorry to hear this from you,</p>
                    <p>Deleting your account will remove all of your information from our database. This cannot be undone.</p>
                    <p>To confirm this verify your mobile number with OTP</p>
                    <input
                        type="text"
                        placeholder="Enter Mobile Number"
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                    />
                    <button onClick={() => { getotp(mobileNumber); sendOtp() }}>SEND OTP</button>

                    {otpSent && (
                        <div className="otp-verification">
                            <p>Enter OTP Code sent to +91{mobileNumber.slice(0, 3)}*****{mobileNumber.slice(8, 10)}</p>
                            <div className="otp-input">
                                <InputOTP
                                    length={4}
                                    otpType="number"
                                    autoFocus
                                    value={otp.split('')}
                                    onChange={(value) => setOtp(value.join(''))}
                                />
                            </div>
                            {/* <div className="otp-timer mt-3">
                                <p>{otpTimer} sec</p>
                            </div> */}
                            <button className='ms-5' onClick={() => { otp_verify(mobileNumber, otp) }}>Verify & Proceed</button>
                        </div>
                    )}

                    {otpVerified && (
                        <button className='bg-danger' onClick={() => { deleteAccount(); delete_acc(uid) }}>Delete your Account</button>
                    )}

                    {showPopup && (
                        <div className="popup">
                            <p>Your relevant data are removed</p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default Home;


